import React from 'react';
import Aux from '../../hoc/Aux';
import Button from '../UI/button/button';




const OrderSummary =(props)=>{


	let listItems= Object.keys(props.ingredients)
					.map((item,i)=>{

						return(
							<li key={item+i}>
							<span style={{textTransform: 'capitalize'}}>
								{item}
							</span>: &nbsp;
							{props.ingredients[item]}
							</li>
							)
					})
	
	return (
		<Aux>
			<h3>Order Summary</h3>
			<p> Your ingredient list:</p>
			<ul>
			{listItems}
			</ul>
			<p style={{fontWeight: 700}}>Total Price: &nbsp; ${parseFloat(props.price.toFixed(2))}</p>
			<Button btnType='Danger' click={props.click}>Cancel</Button>
			<Button btnType='Success' click={props.proceed}>Procced to Checkout</Button>

		</Aux>
		)
}

export default OrderSummary;



// WEBPACK FOOTER //
// ./src/components/OrderSummay/OrderSummary.jsx